
export function IgnoreUrlDelete(req) {
  if (
    !(req.url.includes('ticket/details'))
  ) {
    return true;
  } else {
    return false;
  }
}
export function IgnoreUrlPut(req) {
  if (
    !(req.url.includes('message/specialUser/specific')) &&
    !(req.url.includes('message/specialUser/visit')) &&
    !(req.url.includes('user/common/specific')) &&
    !(req.url.includes('admin/ticket/all')) &&
    !(req.url.includes('post/freePostsSearch')) &&
    !(req.url.includes('post/notFreePostsSearch')) &&
    !(req.url.includes('post/outOfDatePostsSearch')) &&
    !(req.url.includes('ticket/specialUser/details')) &&
    !(req.url.includes('admin/post/specific')) &&
    !(req.url.includes('category/subCategory/all')) &&
    !(req.url.includes('region/subCategory/all')) &&
    !(req.url.includes('admin/post/linkedCatalog/all')) &&
    !(req.url.includes('admin/magazine/common/specific')) &&
    !(req.url.includes('post/linkedMagazine/all')) &&
    !(req.url.includes('admin/post/comment')) &&
    !(req.url.includes('admin/post/score')) &&
    !(req.url.includes('users/ticket/details')) &&
    !(req.url.includes('admin/ticket/details'))
    && !(req.url.includes('contract/specificPost'))
    && !(req.url.includes('contract/payments/specificContract'))
  ) {
    return true;
  } else {
    return false;
  }
}
export function IgnoreUrlPost(req) {
  if (
    !(req.url.includes('ticket/details')) &&
    !(req.url.includes('catalog/uploadImage'))
  ) {
    return true;
  } else {
    return false;
  }
}
